import { useCallback, useState } from 'react'
import { ILineItemWithOrder } from '../../interfaces/Session'
import Button from '../../components/Shared/Button';
import { useModal } from '../../context/Modal';
import { useSession } from '../../components/Session/useSession';
import axios from 'axios';

const StartBattleKartButton = ({ bookings }: { bookings: ILineItemWithOrder[] }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { setModalData, setshowModal } = useModal();
      const { getToken } = useSession();


    const startBattleKartGame = useCallback(async () => {
        try {
            if(bookings.length){
                const variantId = bookings[0].variant_id;
                setIsLoading(true);
                const token = await getToken();
                await axios.post(
                    // "http://127.0.0.1:5001/hyper-karting/us-central1/bkRace",
                    "https://us-central1-hyper-karting.cloudfunctions.net/bkRace",
                    {
                        variantId
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
            }
        } catch (error) {
            console.log(error);
            alert("Error starting Battle Kart Game");
        } finally {
            setIsLoading(false);
        }
    }, [bookings, getToken]);

    const onClick = useCallback(() => {
        setModalData({
            id: 'start-battle-kart-game',
            title: 'Battle Kart Game Confirmation',
            content: <ConformationModalContent onCancel={() => setshowModal(false)} handleGameStart={startBattleKartGame} closeModal={() => setshowModal(false)} />,
            onClose: () => {
                setshowModal(false);
            }
        });
        setshowModal(true);
    }, [setModalData, setshowModal, startBattleKartGame])

    if (bookings.length === 0) {
        return (
            <></>
        );
    }
    return (
        <Button className='bg-[#468e29e9] hover:bg-[#458E29] min-w-max px-2.5 py-1 text-xs font-medium h-auto' onClick={onClick} loading={isLoading} disabled={isLoading}>Start Game</Button>
    )
}

const ConformationModalContent = ({ onCancel, handleGameStart, closeModal }: { onCancel: () => void, handleGameStart: () => Promise<void>, closeModal: () => void }) => {
    const [isLoading, setIsLoading] = useState(false);
    const onSubmit = useCallback(async () => {
        setIsLoading(true);
        await handleGameStart();
        alert("Game started successfully");
        setIsLoading(false);
        closeModal();
    }, [handleGameStart, closeModal]);
    
    return (
        <div className="flex flex-col gap-1">
            <p className="my-4">
                Are you sure you want to start the Battle Kart Game?
            </p>

            <hr className="mt-2" />
            <div className="flex justify-end gap-2 mt-5">
                <button
                    className="items-center px-2.5 py-1 border border-transparent text-xs font-medium shadow-sm text-white focus:outline-none w-max justify-center bg-red-500  hover:bg-red-700 rounded-full"
                    onClick={onCancel}
                >
                    Cancel
                </button>
                <button
                    className="items-center px-2.5 py-1 border border-transparent text-xs font-medium shadow-sm text-white focus:outline-none w-max justify-center bg-green-500  hover:bg-green-700 rounded-full"
                    onClick={onSubmit}
                    disabled={isLoading}
                >
                    {isLoading ? "Sending..." : "Confirm"}
                </button>
            </div>
        </div>
    )
}

export default StartBattleKartButton